import PowerFactorChartPresenter from './Chart/PowerFactorChartPresenter'
import LastPowerFactorPresenter from './LastPowerFactorPresenter'

const PowerFactor = {
  Chart: PowerFactorChartPresenter,
  LastValue: LastPowerFactorPresenter
}

export default PowerFactor

